import styled, { css } from 'styled-components';
import { useEffect, useState } from 'react';
import { Loading } from './Loading';

type TProcessingTooltip = {
  isTooltipVisible: boolean;
  processing: boolean;
  processedMsg: string | null;
};

const Tooltip = styled.div<{ show: boolean }>(
  ({ theme, show }) => css`
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    transition: ${show ? 'opacity 0.35s ease' : 'opacity 0.35s 3s ease'};
    opacity: ${show ? 1 : 0};
  `
);

const Msg = styled.div(
  ({ theme }) => css`
    border-radius: 4px;
    text-align: center;
    width: 151px;
    background-color: ${theme.colors.warmGrey};
    font-size: ${theme.fonts.sizes.h6};
  `
);

const ProcessingTooltip = ({
  isTooltipVisible,
  processing,
  processedMsg
}: TProcessingTooltip) => {
  const [isOpenTransition, setIsOpenTransition] = useState(false);

  useEffect(() => {
    if (isTooltipVisible === true) {
      setIsOpenTransition(true);
    } else {
      setTimeout(() => {
        setIsOpenTransition(false);
      }, 3400);
    }
  }, [isTooltipVisible]);

  return (
    <>
      {isOpenTransition && (
        <Tooltip show={isTooltipVisible}>
          {processing && <Loading small alternative />}
          {!processing && processedMsg && <Msg>{processedMsg}</Msg>}
        </Tooltip>
      )}
    </>
  );
};

export { ProcessingTooltip };
